<!-- Allocation to underlying funds header -->
<h5 class="vg-heading-five underlying-funds-header">Allocation to underlying funds</h5>
<p *ngIf="chartData?.asOfDate; else noData" class="as-of-date vg-paragraph-two vg-gray"
    data-rpa-tag-id="allocationUnderlyingDate">as of {{ chartData?.asOfDate | ESTPipe }}
</p>


<!-- Chart & Table -->
<div class="chart-grid-container" *ngIf="chartAndTable?.length">

    <!-- Chart first always -->
    <div class="chart-container">
        <exemplar-donut-chart [chartId]="chartId" [tableId]="tableId" [chartData]="chartAndTable" [decimals]="2"
            [selectPathData]="selectPathData">
        </exemplar-donut-chart>
    </div>

    <!-- One of two tables next (Table 1) -->
    <div *ngIf="(!!dataSource?.filteredData?.length && portfolioModel?.profileData?.isFundOfFunds && chartData?.asOfDate != null)"
        class="fundOfFundsTable" id="{{tableId}}ExportDiv">
        <mat-table id="{{tableId}}" [ngClass]="{'scrollable-table':isScrollable}" [dataSource]="dataSource" matSort
            matSortActive="name">
            <ng-container matColumnDef="allocationByColor">
                <mat-header-cell *matHeaderCellDef><span [innerHTML]=""></span></mat-header-cell>
                <mat-cell *matCellDef="let row; let indexId = index"><svg id="cr{{indexId}}"
                        class="circle bulletAlignTop">
                        <circle cx="10" cy="10" r="5" />
                    </svg></mat-cell>
            </ng-container>
            <ng-container matColumnDef="name">
                <mat-header-cell *matHeaderCellDef mat-sort-header>
                    <span>Funds</span>
                </mat-header-cell>
                <mat-cell id="donutChartContentName{{indexId}}" *matCellDef="let row; let indexId = index">
                    <span data-rpa-tag-id="longName">
                        <ng-container *ngIf="row.ticker; else noLink">
                            <a [ngClass]="row.disLink ? 'disHref' : ''" c11n-link [variant]="'primary-reinforced'" href="{{row.nameFundLink}}" rel="nofollow">
                                {{row.name}}
                            </a>
                        </ng-container>
                        <ng-template #noLink>
                            <p class="fund-name" [attr.aria-label]="row.name">
                                {{row.name}}
                            </p>
                        </ng-template>
                        <sup *ngIf="row.secutiryKey">{{allocationUnderlyingFootNote?.id}}</sup>
                        <sup *ngIf="row.securityCusip">{{allocationUnderlyingCusipFootNote.id}}</sup>
                    </span>
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="value">
                <mat-header-cell *matHeaderCellDef mat-sort-header><span>{{shortName}}</span></mat-header-cell>
                <mat-cell id="donutChartContentValue{{indexId}}" *matCellDef="let row; let indexId = index"
                    data-rpa-tag-id="longNamePct">
                    {{row.value | percentage: 2}}</mat-cell>
            </ng-container>
            <mat-header-row *matHeaderRowDef="displayedColumnsEtfs">
            </mat-header-row>
            <mat-row id="{{row.id}}TR" *matRowDef="let row; columns: displayedColumnsEtfs;"
                (mouseover)="selectPath(row.id, $event)"></mat-row>
        </mat-table>
    </div>

    <!-- One of two tables next (Table 2)-->
    <div *ngIf="(!!dataSource?.filteredData?.length && portfolioModel?.profileData?.isEtfOfEtfs && chartData?.asOfDate != null)"
            id="{{tableId}}ExportDiv" class="etfOfEtfsTable" #theTable>
            <!-- <button class="right-btn" aria-label="Scroll Right" (click)="moveRight()"
                *ngIf="showRightButton && isScrollable">
            </button>
            <button class="left-btn" aria-label="Scroll Left" (click)="moveLeft()"
                *ngIf="scrollBarPosition>0 && isScrollable">
            </button> -->
            <mat-table id="{{tableId}}" [ngClass]="{'scrollable-table':isScrollable}" [dataSource]="dataSource" matSort
                matSortActive="name">
                <ng-container matColumnDef="allocationByColor" sticky>
                    <mat-header-cell *matHeaderCellDef><span [innerHTML]=""></span></mat-header-cell>
                    <div></div><mat-cell *matCellDef="let row; let indexId = index"><svg id="cr{{indexId}}"
                            class="circle bulletAlignTop">
                            <circle cx="10" cy="10" r="5" />
                        </svg></mat-cell>
                </ng-container>
                <ng-container matColumnDef="name" sticky>
                    <mat-header-cell *matHeaderCellDef mat-sort-header>
                        <div></div><span>Holdings</span>
                    </mat-header-cell>
                    <mat-cell id="donutChartContentName{{indexId}}" *matCellDef="let row; let indexId = index"
                        data-rpa-tag-id="holdings">
                        <ng-container *ngIf="row.disLink; else linkTemplate">
                            <p class="mb-0">{{row.name}}</p>
                        </ng-container>
                        <ng-template #linkTemplate>
                            <a [ngClass]="row.disLink? 'disHref': ''" c11n-link [variant]="'primary-reinforced'" href="{{row.nameLink}}"
                                rel="nofollow">{{row.name}}</a>
                        </ng-template>
                    </mat-cell>
                </ng-container>
                <ng-container matColumnDef="ticker">
                    <mat-header-cell *matHeaderCellDef mat-sort-header><span>Ticker</span></mat-header-cell>
                    <mat-cell id="donutChartContentValue{{indexId}}" *matCellDef="let row; let indexId = index"
                        data-rpa-tag-id="symbol">
                        {{row.ticker}}</mat-cell>
                </ng-container>
                <ng-container matColumnDef="cusip">
                    <mat-header-cell *matHeaderCellDef mat-sort-header><span>CUSIP</span></mat-header-cell>
                    <mat-cell id="donutChartContentValue{{indexId}}" *matCellDef="let row; let indexId = index"
                        data-rpa-tag-id="cusip">
                        {{row.cusip | emDash}}</mat-cell>
                </ng-container>
                <ng-container matColumnDef="sedol">
                    <mat-header-cell *matHeaderCellDef mat-sort-header><span>SEDOL</span></mat-header-cell>
                    <mat-cell id="donutChartContentValue{{indexId}}" *matCellDef="let row; let indexId = index"
                        data-rpa-tag-id="sedol">
                        {{row.sedol | emDash}}</mat-cell>
                </ng-container>
                <ng-container matColumnDef="shares">
                    <mat-header-cell *matHeaderCellDef
                        mat-sort-header><span><span>Shares/</span><br><span>Contracts</span></span></mat-header-cell>
                    <mat-cell id="donutChartContentValue{{indexId}}" *matCellDef="let row; let indexId = index"
                        data-rpa-tag-id="shares">
                        {{row.shares | number | emDash}}</mat-cell>
                </ng-container>
                <ng-container matColumnDef="market">
                    <mat-header-cell *matHeaderCellDef mat-sort-header><span>Market Value
                            <sup>*</sup></span></mat-header-cell>
                    <mat-cell id="donutChartContentValue{{indexId}}" *matCellDef="let row; let indexId = index"
                        data-rpa-tag-id="marketValue">
                        {{row.marketValue | currency:'USD':'symbol':'1.2-2' | emDash}}</mat-cell>
                </ng-container>
                <ng-container matColumnDef="notional">
                    <mat-header-cell *matHeaderCellDef mat-sort-header><span>Notional
                            Value</span></mat-header-cell>
                    <mat-cell id="donutChartContentValue{{indexId}}" *matCellDef="let row; let indexId = index"
                        data-rpa-tag-id="notionalValue">
                        {{row.notionalValue | currency:'USD':'symbol':'1.2-2' | emDash}}</mat-cell>
                </ng-container>
                <ng-container matColumnDef="value">
                    <mat-header-cell *matHeaderCellDef mat-sort-header><span>% of funds <sup>*</sup>
                        </span></mat-header-cell>
                    <mat-cell id="donutChartContentValue{{indexId}}" *matCellDef="let row; let indexId = index"
                        data-rpa-tag-id="fundPercent">
                        {{row.value | percentage: 2}}</mat-cell>
                </ng-container>
                <mat-header-row *matHeaderRowDef="displayedColumns">
                </mat-header-row>
                <mat-row id="{{row.id}}TR" *matRowDef="let row; columns: displayedColumns;"
                    (mouseover)="selectPath(row.id, $event)"></mat-row>
            </mat-table>
        </div>
        <div class="summary-table-footnote" *ngIf="(!!dataSource?.filteredData?.length && portfolioModel?.profileData?.isEtfOfEtfs && chartData?.asOfDate != null)">
            <p class="vg-paragraph-two">*There may be deviations when applying fair value and other considerations.
            </p>
        </div>
</div>

<ng-template #noData>
    <div class="col-sm-12">
        <p class="no-data vg-paragraph-one">This information is temporarily unavailable.</p>
    </div>
</ng-template>